import React from "react";
import { useIntl } from "react-intl";
import { Plus } from "react-feather";
import "./styles.scss";

const NewCpfCnpjButton = ({ textId, onClick, isLoading, ...props }) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <button
        className={`button ${isLoading ? " is-loading" : ""}`}
        onClick={onClick}
      >
        <Plus size="12" /> {formatMessage({ id: textId })}
      </button>
    </>
  );
};

export default NewCpfCnpjButton;
